import Component from '../core/Component'
import EventBus from '../core/EventBus'
import StoresMap from './StoresMap'


export default class StoreAvailability extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            map: null
        }

        this.map = null
    }

    prepare() {
        EventBus.on('modal:open', this.handleModalOpen)

        const modal = Component.getFromElement(this.element.closest('[data-component="Modal"]'))

        if (modal?.isOpen()) {
            this.handleModalOpen({
                id: modal.element.id
            })
        }
    }

    destroy() {
        EventBus.off('modal:open', this.handleModalOpen)
        this.map?.destroy()
    }

    handleModalOpen = ({ id }) => {
        const modal = this.element.closest('[data-component="Modal"]')

        if (modal?.id === id && this.ref.map) {
            this.map = new StoresMap(this.ref.map)
            this.map.prepare()
        }
    }

}
